import Markdown from 'react-markdown';

import remarkGfm from 'remark-gfm';
import { remarkMark } from 'remark-mark-highlight';

import { MyList } from '../MyList';

const MarkDownRender = ({ ...props }: any) => {
  let markdown = props.children;
  if (markdown && typeof markdown === 'object' && Array.isArray(markdown)) {
    markdown = markdown.join('');
  }
  return (
    <Markdown
      // @ts-expect-error
      remarkPlugins={[remarkGfm, remarkMark]}
      // biome-ignore lint/correctness/noChildrenProp: Keeping for backwards compatibility
      children={markdown}
      components={{
        ul(props: any) {
          return renderList(props, 'disc');
        },
        ol(props: any) {
          return renderList(props, 'decimal');
        },
      }}
    />
  );
};

function renderList(props: any, type: string) {
  const { children, className: _className, node: _node, ...rest } = props;

  return (
    <MyList {...rest} className={`list-inside list-${type}`}>
      {children}
    </MyList>
  );
}

export default MarkDownRender;
